import LineHeartClickIcon from 'LuxKit/Icons/line/LineHeartClickIcon'
import LinePhoneAltIcon from 'LuxKit/Icons/line/LinePhoneAltIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import { NO_24_7_SUPPORT_REGIONS } from 'constants/config/region'
import { isNonNullable } from 'lib/array/arrayUtils'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import type { MessageDescriptor } from 'react-intl'
import { defineMessages } from 'react-intl'
import { createSelector } from 'reselect'

export interface HomepageUspsContentItem {
  Icon: typeof SvgIcon
  bodyMessage: MessageDescriptor
}

const uspMessages = defineMessages({
  trustedBy: {
    id: 'jKjSaRxmzAfBEkwuOfm4',
    defaultMessage: 'Trusted by 15 million+ travellers worldwide',
    description: 'Front page USP selling point about the number of travellers who trust the brand',
  },
  exclusiveOffers: {
    id: '03fUsMsAu11d1_P9-K2b',
    defaultMessage: 'Unlock thousands of exclusive offers with exceptional value',
    description: 'Front page USP selling point about exclusive member-only travel offers',
  },
  societePoints: {
    id: 'xkM71CLw7Rm5t8F_SwN4',
    defaultMessage: 'Earn & redeem Société Points with every booking',
    description: 'Front page USP selling point about earning and redeeming Société loyalty points',
  },
  support247: {
    id: '8Fby3E6C7pjFdAVc7cv_',
    defaultMessage: 'Our team are available 24 hours, 7 days',
    description: 'Front page USP selling point about round-the-clock customer service availability',
  },
  supportLimited: {
    id: 'RVg2V78hIh9PPjdLVSHt',
    defaultMessage: 'Our customer service team is available 9am to 7pm every day',
    description: 'Front page USP selling point about daily customer service availability hours',
  },
})

const getHomepageUspsContent = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => getIsLoyaltyEnabled(state),
  (
    currentRegionCode,
    isLoyaltyEnabled,
  ): Array<HomepageUspsContentItem> => {
    const no247Support = NO_24_7_SUPPORT_REGIONS.includes(currentRegionCode)

    return [
      {
        Icon: LineHeartClickIcon,
        bodyMessage: uspMessages.trustedBy,
      },
      {
        Icon: LineTagAltIcon,
        bodyMessage: uspMessages.exclusiveOffers,
      },
      isLoyaltyEnabled ? {
        Icon: LineStarIcon,
        bodyMessage: uspMessages.societePoints,
      } : undefined,
      {
        Icon: LinePhoneAltIcon,
        bodyMessage: no247Support ? uspMessages.supportLimited : uspMessages.support247,
      },
    ].filter(isNonNullable)
  },
)

export default getHomepageUspsContent
